<template>
  <div class="spa-nav woocommerce-MyAccount-navigation">

    <nav>

        <ul class="ticket_navigation" v-if="isWeitererUser">

          <li>
            <a href="/konto/">Dashboard</a>
          </li>

          <li>
            <a href="/konto/validierung/">Validierung</a>
          </li>

          <li>
            <a href="/anwendung/">Journal</a>
          </li>

          <li>
            <a href="/anwendung/#/archivsuche/">Archivsuche</a>
          </li>

          <li class="is-active">
            <router-link
              to="/"
              class="nav-item nav-link"
              active-class="active_ticket"
              role="link">Support
            </router-link>
          </li>

          <li>
            <a href="/konto/einstellungen/">Einstellungen</a>
          </li>


        </ul> <!-- .nav -->


        <ul class="ticket_navigation" v-else>

          <li>
            <a href="/konto/">Dashboard</a>
          </li>

          <li>
            <a href="/konto/validierung/">Validierung</a>
          </li>

          <li>
            <a href="/anwendung/">Journal</a>
          </li>

          <li>
            <a href="/anwendung/#/archivsuche/">Archivsuche</a>
          </li>

          <li class="is-active">
            <router-link
              to="/"
              class="nav-item nav-link"
              active-class="active_ticket"
              role="link">Support
            </router-link>
          </li>

          <li>
            <a href="/konto/einstellungen/">Einstellungen</a>
          </li>

          <li>
            <a href="/konto/orders/">Verwaltung</a>
          </li>

          <li>
            <a href="/konto/erweiterungen/">Erweiterungen</a>
          </li>

        </ul> <!-- .nav -->

    </nav> <!-- navbar -->

  </div><!-- #spa-nav -->
</template>

<script>
export default {

	/*global wpData:true*/
	/*eslint no-undef: "error"*/
	 data() {
		  return {

		  };
	 },
   computed: {
        isWeitererUser() {
            if (this.$store.getters.getWeitererUser) {
                return true;
            } else {
                return false;
            }
        }
   }

};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppNavigation.vue